import { render, staticRenderFns } from "./editorregistrationname.vue?vue&type=template&id=7f8edd7b&scoped=true"
import script from "./editorregistrationname.vue?vue&type=script&lang=js"
export * from "./editorregistrationname.vue?vue&type=script&lang=js"
import style0 from "./editorregistrationname.vue?vue&type=style&index=0&id=7f8edd7b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8edd7b",
  null
  
)

export default component.exports